import React from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadSection } from '../../../modules/backend/openapi/api-types';
import { Typography } from '../../../visual-components/typography/typography';
import { Link } from '../../../visual-components/link/link';
import { Spacer } from '../../../visual-components/spacer/spacer';
import { LinkList } from '../../../visual-components/link-list/link-list';
import { Accordion } from '../../../visual-components/accordion/accordion';
import { notNil } from '../../../core/helpers/is-nil';

type Props = {
  downloads: DownloadSection | null;
  certificates: DownloadSection[];
};

export const Downloads: React.FC<Props> = ({ downloads, certificates }) => {
  const { t } = useTranslation();

  const hasDownloads = notNil(downloads);
  const hasCertificates = certificates.length > 0;

  return (
    <>
      {hasDownloads ? (
        <>
          <Typography variant="headline-3">{downloads.name}</Typography>
          <Spacer size="06" />
          <LinkList>
            {downloads.downloads.map((download, i) => (
              <Link key={`${download.title}-${i}`} icon="arrow-down-stroke-bottom" to={download.url}>
                {download.title}
              </Link>
            ))}
          </LinkList>
        </>
      ) : null}
      {hasCertificates ? (
        <>
          <Spacer size="07" />
          <Accordion
            title={t('articleDetail.certificates')}
            items={certificates.map(({ name, downloads }, i) => ({
              value: `${name}-${i}`,
              triggerText: name,
              content: (
                <LinkList>
                  {downloads.map((download, j) => (
                    <Link key={`${download.title}-${j}`} icon="arrow-down-stroke-bottom" to={download.url}>
                      {download.title}
                    </Link>
                  ))}
                </LinkList>
              ),
            }))}
          />
        </>
      ) : null}
    </>
  );
};
